import React, { useState, useEffect, useMemo } from "react";
import { PanelService } from "../../../network/panel/network";
import { GroupOffersBy, IOffersAdminResponse, TOffer } from "types/offers-temporary";
import "./_offers.scss"
import OfferSmall from "ui/components/offers/offer-small";
import { OfferCrudModal } from "ui/modals/offer/offer-crud";
import { KeitaroImportModal } from "ui/modals/offer/keitaro-import-modal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { createLogger } from '../../../utils/logger';

const logger = createLogger('offers');

const Offers: React.FC = () => {
  const [offers, setOffers] = useState<IOffersAdminResponse | null>(null);
  const [offerToEdit, setOfferToEdit] = useState<TOffer | null>(null);
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");

  const fetchOffers = async () => {
    try {
      logger.info('Fetching flat PDL offer list');
      const response = await PanelService.getAllOffers(GroupOffersBy.PLAIN, false, true);
      logger.info('Offers response', {
        plain: response.plain?.length || 0,
        partners: response.partners?.length || 0
      });
      setOffers(response);
    } catch (error) {
      logger.error('Error fetching offers', error);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  // PDL exposes one flat MFO offer pool; partner/category grouping never controls visibility.
  const filteredOffers = useMemo(() => {
    if (!offers) return [];
    
    const query = search.toLowerCase().trim();
    return (offers.plain || []).filter((offer: TOffer): boolean => {
      if (!query) return true;
      return offer.id?.toString().includes(query)
        || offer.name?.toLowerCase().includes(query)
        || offer.caption?.toLowerCase().includes(query)
        || offer.geo?.toLowerCase().includes(query);
    });
  }, [offers, search]);

  return (
    <div className="offers">
      <div className="offers-header">
        <div className="offers-header-content">
          <div className="offers-actions">
            <button 
              className="lists-tab create-offer-btn"
              onClick={() => setShowCreateModal(true)}
            >
              Створити офер
            </button>
            <span className="offers-separator" />
            <button
              className="lists-tab import-keitaro-btn"
              onClick={() => setShowImportModal(true)}
            >
              Імпорт з Keitaro
            </button>
          </div>
          <div className="offers-search">
            <div className="lists-search">
              <input
                type="text"
                placeholder="Пошук"
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="lists-search-input"
              />
              <FontAwesomeIcon icon={faSearch} className="lists-search-icon" />
            </div>
          </div>
        </div>
      </div>

      <div className="offers-content">
        {filteredOffers.length > 0 && (
          <div className="partners-section" style={{ marginTop: '12px' }}>
            <span className="partners-title noselect">Всі офери ({filteredOffers.length})</span>
            <div className="offers-column">
              {filteredOffers.map((offer: TOffer) => (
                <OfferSmall onClick={setOfferToEdit} offer={offer} key={offer.id} showCountry={true} />
              ))}
            </div>
          </div>
        )}
        {filteredOffers.length === 0 && (
          <div className="no-results-placeholder">
            <span className="no-results-icon">🔍</span>
            <span className="no-results-text">{search ? 'Нічого не знайдено' : 'Офери відсутні'}</span>
            <span className="no-results-hint">{search ? 'Спробуйте інший пошуковий запит' : 'Створіть новий офер'}</span>
          </div>
        )}
        {offers && offerToEdit && <OfferCrudModal offer={offerToEdit} offers={offers.plain || []} partners={offers.partners} onClose={() => setOfferToEdit(null)} onSave={fetchOffers} />}
        {offers && showCreateModal && <OfferCrudModal offers={offers.plain || []} partners={offers.partners} onClose={() => setShowCreateModal(false)} onSave={fetchOffers} />}
        {showImportModal && <KeitaroImportModal onClose={() => setShowImportModal(false)} onImported={fetchOffers} />}
      </div>
    </div>
  )
};

export default Offers;
